import { render, staticRenderFns } from "./CellRendererCreateDate.vue?vue&type=template&id=70815d05&"
import script from "./CellRendererCreateDate.vue?vue&type=script&lang=js&"
export * from "./CellRendererCreateDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports